import axios from "axios";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import constants from "../Constants";
import { QIKTRUCK_CONSUMER_SITE } from "../constants/mobileApp";
import { saveMediaAccessCookie } from "./mediaAccessCookie";
import { isCustomerPaidToQikTruck } from "./paymentSettlement";

const baseURL = constants.baseURL;

/** Customer-facing "paid" = settled with QikTruck, not driver payout. */
export function isOrderPaid(order) {
  return isCustomerPaidToQikTruck(order);
}

export function getTrackOrderPayUrl(order, emailOverride) {
  const orderid = order?.orderid;
  if (!orderid) return null;
  const email = (emailOverride || order?.email || "").trim();
  const params = new URLSearchParams({
    orderid: String(orderid),
    paynow: "yes",
  });
  if (email) params.set("email", email);
  return `${QIKTRUCK_CONSUMER_SITE}/track-order?${params.toString()}`;
}

export function downloadCustomerInvoice(invoiceId, authorization) {
  const pdfTab = window.open("", "_blank");
  if (pdfTab) {
    pdfTab.document.title = `Invoice ${invoiceId}`;
    pdfTab.document.body.innerHTML =
      '<p style="font-family:system-ui,sans-serif;padding:2rem">Generating invoice PDF…</p>';
  }

  const toastId = toast.info(`Generating invoice #${invoiceId}…`, {
    autoClose: false,
    closeButton: false,
  });

  return axios
    .post(
      `${baseURL}/customer-invoice-download`,
      { invoiceid: invoiceId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: authorization,
        },
      }
    )
    .then((response) => {
      saveMediaAccessCookie(authorization || cookie.load("session-id-qt"));
      const url =
        response.data?.url ||
        `https://media.admin.qiktruck.co.za/${invoiceId}.pdf`;

      if (pdfTab && !pdfTab.closed) {
        pdfTab.location.href = url;
      } else {
        window.location.assign(url);
      }

      toast.update(toastId, {
        render: pdfTab
          ? `Invoice #${invoiceId} opened in a new tab`
          : `Invoice #${invoiceId} opened - allow pop-ups to open in a new tab next time`,
        type: "success",
        autoClose: 5000,
        closeButton: true,
        isLoading: false,
      });
    })
    .catch((error) => {
      console.error("Error downloading invoice:", error);
      if (pdfTab && !pdfTab.closed) {
        pdfTab.close();
      }
      toast.update(toastId, {
        render: `Could not download invoice #${invoiceId}. Try again or contact support.`,
        type: "error",
        autoClose: 6000,
        closeButton: true,
        isLoading: false,
      });
      throw error;
    });
}
